import { PRODUCT_CONFIG_OPTIONS, PRODUCTS } from '@boltenergy-be/shared'

export const PRODUCT_COMPARISON_KEYS = [
  PRODUCT_CONFIG_OPTIONS.platformCost,
  PRODUCT_CONFIG_OPTIONS.type,
  PRODUCT_CONFIG_OPTIONS.directDebitMandatory,
  PRODUCT_CONFIG_OPTIONS.contactOptions,
  PRODUCT_CONFIG_OPTIONS.billingOptions,
  'bestInjection'
] as const
export type ProductComparisonKeys = (typeof PRODUCT_COMPARISON_KEYS)[number]

export const PRODUCT_EXTRA_OPTIONS = ['dynamicTariff', 'monthlyBilling'] as const
export type ProductExtraOptions = (typeof PRODUCT_EXTRA_OPTIONS)[number]

// The order of the products in this array will be the order in which they are displayed in the table
export const BOLT_PRICING_PRODUCTS = [PRODUCTS.fix, PRODUCTS.variableOffline, PRODUCTS.variableOnline]
export const PLENTY_PRICING_PRODUCTS = [PRODUCTS.plentyFix, PRODUCTS.plentyVariableOffline, PRODUCTS.plentyVariableOnline]
